import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Curso, CursosService } from "src/app/services/curso.service";

@Component({
  selector: "app-curso-page",
  templateUrl: "./curso-page.component.html",
})
export class CursoPageComponent implements OnInit {
  public curso: Curso | any;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private cursosService: CursosService
  ) {}

  ngOnInit(): void {
    this.route.paramMap.subscribe((params) => {
      const slug = params.get("slug");

      if (slug) {
        this.cursosService.getCursoBySlug(slug).subscribe((data: any) => {
          if (!data) {
            this.router.navigate(["/"]);
            return;
          }

          this.curso = data;
        });
      }
    });
  }
}
